import { render, staticRenderFns } from "./LastTransactionsList.vue?vue&type=template&id=bc01e8b4&"
import script from "./LastTransactionsList.vue?vue&type=script&lang=js&"
export * from "./LastTransactionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports